import * as React from 'react';

// COMPONENTS
import Button from './Button';
import OrganisationLogo from './OrganisationLogo';

// ICONS
import { ReactComponent as PlusIcon } from '../assets/svg/plus.svg';

// TYPES
import { StaffFetchOrganisation } from '../api/models/staff-fetch-organisation';

interface ProfileLinkedAccountsTypes {
	organisations?: Array<StaffFetchOrganisation>;
	isStudent?: boolean;
	defaultMaxItems?: number;
	isYou?: boolean;
}

const ProfileLinkedAccounts: React.FC<ProfileLinkedAccountsTypes> = ({
	organisations,
	isStudent,
	defaultMaxItems,
	isYou
}) => {
	const [maxOrganisationsItem, setMaxOrganisationsItem] = React.useState<number>(defaultMaxItems || 5);

	return (
		<>
			{organisations && organisations.length > 0 && (
				<section className="info-section">
					<div className="section-header">
						<h2 className="header-name color-dark">Organisations</h2>
					</div>

					{organisations.slice(0, maxOrganisationsItem).map((item, index) => {
						return (
							<div key={index} className="row-container">
								<div className="row detail-row">
									<div className="col-auto pdl-0 pdr-0">
										<OrganisationLogo src={item.imageUrl} size={40} />
									</div>

									<div className="col-md-auto full-width">
										<div className="row detail-info">
											<div className="col-lg-4 detail-name">{item.name}</div>

											<div className="col-lg-4 detail-status">
												<div className="title">{item.isCurrentMember ? "" : "Past"} Role</div>

												<div className="name">{isStudent ? <>Child / Student</> : item.role}</div>
											</div>

											<div className="col-lg-4 detail-status">
												<div className="status mr-0">{item.isLeadershipTeamMember}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						);
					})}

					{maxOrganisationsItem < organisations.length && (
						<Button
							className="btn-secondary btn-show-more"
							onClick={() => setMaxOrganisationsItem(organisations.length)}
							buttonIcon={<PlusIcon className="link-icon" />}
						>
							Show {organisations.length - maxOrganisationsItem} more
						</Button>
					)}
				</section>
			)}
		</>
	);
};

export default ProfileLinkedAccounts;
